import App from "./App.svelte";
import "./styles/main.scss";
import "./i18n";
const app = new App({
    target: document.body,
});
export default app;
